import withScrollTo from './withScrollTo';

export default function withScrollToTop(Component) {
    return withScrollTo('body', true)(Component);
}
